const ProfileClient = {
  profileUrl: "candidates/profile",
};

export default ProfileClient;
